import { render, staticRenderFns } from "./patientTree.vue?vue&type=template&id=1f6f8dc6&scoped=true"
import script from "./patientTree.vue?vue&type=script&lang=js"
export * from "./patientTree.vue?vue&type=script&lang=js"
import style0 from "./patientTree.vue?vue&type=style&index=0&id=1f6f8dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6f8dc6",
  null
  
)

export default component.exports